import {dayjs} from '@/plugins/dayjs'
import {useI18n} from 'vue-i18n';

export function usePriceFormat(currency = 'EUR') {

    const formatPrice = (price, decimals = 2) => {
        const formatter = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        });

        return formatter.format(price);
    }

    return {
        formatPrice
    }
}
